import { type ILayoutConfig } from '@/providers/LayoutProvider';

const authLayoutConfig: ILayoutConfig = {
  // Setting the layout name to 'auth'
  name: 'auth',

  // Options object is currently empty but can be extended with layout-specific configurations
  options: {}
};

export { authLayoutConfig };
